export const StatutesTexts = ['Queue', 'Development', 'Done'];

export const PriorityTexts = ['Низкий', 'Средний', 'Высокий'];

export enum Statutes {
  Queue = 'Queue',
  Development = 'Development',
  Done = 'Done',
}
